import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';

export function Dashboard() {
  const [sites, setSites] = useState<any[]>([]);
  useEffect(() => { api.get('/api/sites').then(setSites).catch(() => {}); }, []);
  const numAtgs = sites.reduce((s, x) => s + (x.atgs?.length || 0), 0);
  return (
    <>
      <div className="card">
        <h2>Overview</h2>
        <div className="kpi">
          <div className="item"><div className="label">Sites</div><div className="val">{sites.length}</div></div>
          <div className="item"><div className="label">ATGs</div><div className="val">{numAtgs}</div></div>
          <div className="item"><div className="label">Active polling</div><div className="val">{numAtgs ? 'On' : '—'}</div></div>
        </div>
      </div>
      <div className="card">
        <h2>Sites</h2>
        {sites.length === 0 && <div style={{ color: 'var(--muted)' }}>No sites yet. <Link to="/sites">Add one →</Link></div>}
        <div className="table-wrap"><table>
          <thead><tr><th>Name</th><th>Customer</th><th>ATGs</th><th /></tr></thead>
          <tbody>
            {sites.map(s => (
              <tr key={s.id}>
                <td>{s.name}</td><td>{s.customer || '—'}</td><td>{s.atgs?.length || 0}</td>
                <td><Link to={`/sites/${s.id}`}>Open →</Link></td>
              </tr>
            ))}
          </tbody>
        </table></div>
      </div>
    </>
  );
}
